<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Emailage</h3>
        </div>

        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
              v-b-tooltip.hover.bottom
              title="Filtros"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
            <button
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Informações"
              @click="Info()"
            >
              <i class="fas fa-info"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Consultas Emailage</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">E-mail</th>
                    <th scope="col" class="border-0">Banda de Risco</th>
                    <th scope="col" class="border-0">Descrição</th>
                    <th scope="col" class="border-0">Consultas</th>
                    <th scope="col" class="border-0">Data de Criação</th>
                    <th scope="col" class="border-0">Última Atualização</th>
                    <th
                      scope="col"
                      class="border-0"
                      v-if="$isAuthorize('Emailage', 'Get')"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(emailage, index) in listEmailage" :key="index">
                    <td></td>
                    <td class="text-left">{{ emailage.Email }}</td>

                    <td>{{ emailage.RiskBandID }}</td>
                    <td>{{ emailage.RiskBand }}</td>
                    <td>{{ emailage.Hits }}</td>
                    <td class="td-with-subs">
                      <div>{{ emailage.CreatedDate | date }}</div>
                      <span>{{ emailage.CreatedDate | date("HH:mm:ss") }}</span>
                    </td>
                    <td class="td-with-subs">
                      <div>{{ emailage.LastUpdate | date }}</div>
                      <span>{{ emailage.LastUpdate | date("HH:mm:ss") }}</span>
                    </td>
                    <td v-if="$isAuthorize('Emailage', 'Get')">
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenEmailage($event, index)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      listEmailage == undefined ||
                      listEmailage == null ||
                      listEmailage.length == 0
                    "
                  >
                    <td colspan="8">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="lg"
      id="mFormMerchant"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <template v-slot:modal-header>
        <h5 class="col-10 no-gutters mb-0">
          Consulta
          <template>
            {{ infoEmailage.Email }}
            <template v-if="isSeeing">[{{ infoEmailage.Id }}]</template>
          </template>
        </h5>
        <button class="close" @click="HideModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <loader :is-loading="loadingMerchant"></loader>
      <div v-if="!loadingMerchant">
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Email</label>
            <d-form-input
              type="text"
              v-model="infoEmailage.Email"
              :disabled="isSeeing"
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Consultas</label>
            <d-form-input
              type="text"
              v-model="infoEmailage.Hits"
              :disabled="isSeeing"
            />
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Banda de risco</label>
            <d-form-input
              type="text"
              v-model="infoEmailage.RiskBandID"
              :disabled="isSeeing"
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Descrição</label>
            <d-form-input
              type="text"
              v-model="infoEmailage.RiskBand"
              :disabled="isSeeing"
            />
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Data de criação</label>
            <d-form-input
              type="text"
              v-bind:value="
                infoEmailage.CreatedDate | date('DD/MM/YYYY - HH:mm')
              "
              readonly
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Data da última atualização</label>
            <d-form-input
              type="text"
              v-bind:value="
                infoEmailage.LastUpdate | date('DD/MM/YYYY - HH:mm')
              "
              :disabled="isSeeing"
            />
          </d-col>
        </d-form-row>

        <d-form-row>
          <d-col md="12" class="form-group">
            <label v-b-tooltip.hover title="JSON">Json</label>
            <b-form-textarea
              type="text"
              readonly
              :rows="18"
              :value="infoEmailage.Json"
            />
          </d-col>
        </d-form-row>
      </div>
      <template slot="modal-footer">
        <b-button-group>
          <b-button size="sm" class="btn btn-secondary" hidden>
            <i class="fas fa-arrow-left"></i>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>

    <b-modal
      id="mInfo"
      title="Informações"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <table class="table mb-0" v-if="!loadingList">
        <thead class="bg-s2p-gray-light">
          <tr>
            <th scope="col" class="border-0 text-left">Banda de Risco</th>
            <th scope="col" class="border-0">Descrição</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Fraud Score 1 to 100</td>
          </tr>
          <tr>
            <td>2</td>
            <td>Pontuação de Fraude 101 para 300</td>
          </tr>
          <tr>
            <td>3</td>
            <td>Pontuação de Fraude 301 para 600</td>
          </tr>
          <tr>
            <td>4</td>
            <td>Pontuação de Fraude 601 para 799</td>
          </tr>
          <tr>
            <td>5</td>
            <td>Pontuação de Fraude 800 para 899</td>
          </tr>
          <tr>
            <td>6</td>
            <td>Pontuação de Fraude 900 para 999</td>
          </tr>
        </tbody>
      </table>

      <template slot="modal-footer"></template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="4" class="form-group">
          <input
            placeholder="E-mail"
            type="text"
            class="form-control"
            v-model="filter.Email"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="4" class="form-group">
          <date-field
            v-model="filter.CreatedDate"
            placeholder="Data de Criação"
          ></date-field>
        </d-col>
        <d-col md="4" class="form-group">
          <date-field
            v-model="filter.LastUpdate"
            placeholder="Última atualização"
          ></date-field>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "emailage",
  components: {
    dateField,
  },
  data: function () {
    return {
      countFilter: 0,
      filter: {
        Email: null,
        CreatedDate: null,
        LastUpdate: null,
      },
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      infoEmailage: {
        Json: null,
        Id: null,
      },
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      listEmailage: [],
      idEmailage: null,
      isSeeing: true,
      loadingMerchant: false,
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListEmailage();
    },
    "pagination.RowsPerPage": function () {
      this.ListEmailage();
    },
  },
  mounted() {
    this.ListEmailage();
  },
  methods: {
    ResetInfoEmailage: function () {
      this.infoEmailage = {
        Json: null,
        Id: null,
      };
    },
    GetEmailage: function (id) {
      this.loadingMerchant = true;
      this.$store
        .dispatch("GetEmailage", { id: id })
        .then((response) => {
          this.infoEmailage = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter as informações do email",
            error
          );
        })
        .finally(() => {
          this.loadingMerchant = false;
        });
    },
    OpenEmailage: function (e, i, view) {
      e.preventDefault();
      this.ResetInfoEmailage();
      this.idEmailage = this.listEmailage[i].Id;
      this.isSeeing = true;
      this.GetEmailage(this.idEmailage);
      this.$bvModal.show("mFormMerchant");
    },
    HideModal: function () {
      this.$bvModal.hide("mFormMerchant");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListEmailage();
    },
    ListEmailage: function () {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Email)) this.countFilter++;
      if (hasValue(this.filter.CreatedDate)) this.countFilter++;
      if (hasValue(this.filter.LastUpdate)) this.countFilter++;

      let data = {
        ...this.pagination,
        ...{
          "Object.Email": this.filter.Email,
          "Object.CreatedDate": this.filter.CreatedDate,
          "Object.LastUpdate": this.filter.LastUpdate,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListEmailage", { params: data })
        .then((response) => {
          this.listEmailage = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as consultas de e-mail",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Info: function () {
      this.$bvModal.show("mInfo");
    },
    ResetFilter: function () {
      this.filter = {
        Email: null,
        CreatedDate: null,
        LastUpdate: null,
      };
      this.ListEmailage();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/emailage.vue